import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../messages';
import type { UserDataType } from '../../../../model';
import { NoCardChooseSignup } from '../sign-up-form/components/styled';
import {
  ChooseSignupFormHeaderHeading,
  ChooseSignupFormHeaderSubheading,
  FormHeaderHeading,
  FormHeaderRoot,
  FormHeaderSubheading
} from './styled';
import { useExperiment } from '@atlassiansox/bxp-web-statsig-client';
import { ProductKeysType, Url } from '@atlassiansox/bxpkit-core';

export interface SignUpFormHeaderProps {
  heading: FormattedMessage.MessageDescriptor;
  subheading: FormattedMessage.MessageDescriptor;
  userInfo: UserDataType;
  allowSignupWithAllSocialOptions?: boolean;
  products?: ProductKeysType[];
}

function SignUpFormHeader({
  heading,
  subheading,
  userInfo,
  allowSignupWithAllSocialOptions,
  products
}: SignUpFormHeaderProps) {
  const shouldShowGreeting = userInfo?.isLoggedIn;
  const shouldShowSubheading =
    Boolean(subheading.defaultMessage) && !userInfo?.isLoggedIn;
  const experiment = useExperiment('frontend_site_name_additional_copy');
  const { site_name_additional_copy, site_name_generation } = experiment.value;
  const isNewUser = userInfo?.isNewUser;
  const isPaid = !Url.getUrl()?.includes('/try/cloud/signup');
  const isJiraOrConfluenceFree =
    (products ?? []).filter(
      (item) =>
        (item.product.includes('jira-software') ||
          item.product.includes('confluence')) &&
        item.edition === 'free'
    ).length === 1;

  const isConfluence =
    (products ?? []).filter((item) => item.product.includes('confluence'))
      .length > 0;

  const isNewUserInSiteNameExperiment =
    (site_name_additional_copy || site_name_generation) &&
    isNewUser &&
    isJiraOrConfluenceFree &&
    !isPaid;
  const greeting = isNewUserInSiteNameExperiment
    ? messages.personalizedNameSiteMessage
    : messages.greeting;

  if (allowSignupWithAllSocialOptions && !isConfluence) {
    return (
      <FormHeaderRoot>
        <ChooseSignupFormHeaderHeading style={{ marginBottom: '8px' }}>
          <FormattedMessage {...heading} />
        </ChooseSignupFormHeaderHeading>
        <ChooseSignupFormHeaderSubheading style={{ marginBottom: '24px' }}>
          <FormattedMessage {...messages.freeAndNoCreditCardNeeded} />
        </ChooseSignupFormHeaderSubheading>
      </FormHeaderRoot>
    );
  }

  return (
    <FormHeaderRoot>
      {isConfluence && !shouldShowGreeting ? (
        <ChooseSignupFormHeaderHeading>
          <FormattedMessage {...heading} />
        </ChooseSignupFormHeaderHeading>
      ) : (
        <FormHeaderHeading isGreeting={shouldShowGreeting}>
          {shouldShowGreeting ? (
            <FormattedMessage
              {...greeting}
              values={{
                username: userInfo.firstName
              }}
            />
          ) : (
            <FormattedMessage {...heading} />
          )}
        </FormHeaderHeading>
      )}
      {isConfluence && !shouldShowGreeting && (
        <NoCardChooseSignup>
          <FormattedMessage {...messages.noCard} />
        </NoCardChooseSignup>
      )}
      {shouldShowSubheading &&
        (!isConfluence ? (
          <FormHeaderSubheading>
            <FormattedMessage {...subheading} />
          </FormHeaderSubheading>
        ) : (
          <ChooseSignupFormHeaderSubheading>
            <FormattedMessage {...subheading} />
          </ChooseSignupFormHeaderSubheading>
        ))}
    </FormHeaderRoot>
  );
}

export default SignUpFormHeader;
